(function ThankYouModalDesktopPaid() {
    'use strict';

    /**
     * Toggles the visibility of a modal element by adding or removing the 'hidden' attribute.
     * @param {HTMLElement} modal - The modal element to toggle.
     */
    function toggleModal(modal) {
        modal.toggleAttribute('hidden');
    }

    /**
   * Handles the click event for creating an account.
   */
    function handleCreateAccountClick() {
        if (window.auth0Dom) {
            window.auth0Dom.signIn();
        }
    }

    /**
    * Handles the click event for the close button in the modal.
    * Reveals the modal background by removing the 'hidden' attribute,
    * and attempts to remove the 'hidden' attribute from the modal element.
    */
    function closeButtonClickHandler() {
        const modalBackground = document.querySelector('[data-modal-background]');
        const modal = document.getElementById('modal');

        if (modalBackground) {
            modalBackground.hidden = false;
        }

        if (modal) {
            modal.hidden = false;
        }
    }

    /**
     * Handles the click event for downloading the brochure PDF.
     */
    function triggerDownloadBrochure(pdfBrochureUrl, listingName, pdfBrochureBlob) {
        const thankYouModal = document.querySelector('[data-thank-you-modal-paid]');
        const modalRecommendedCommunities = document.querySelector('[data-modal-recommended-communities]');
        const modalElements = [thankYouModal, modalRecommendedCommunities].filter(Boolean);

        closeButtonClickHandler();

        if (pdfBrochureUrl) {
            window.NewHomeSource.BrochureHandler.getPdfBrochure(pdfBrochureUrl, listingName, pdfBrochureBlob);

            // Automatically close the modal after 3 seconds
            setTimeout(() => {
                modalElements.forEach(toggleModal);
            }, 3000);
        }
    }

    /**
     * Attaches events to the thank you modal element.
     * @param {string} pdfBrochureUrl - The URL to fetch the brochure PDF.
     * @param {string} listingName - The name of the listing.
     * @param {Blob|null} pdfBrochureBlob - The already fetched PDF blob, if available.
     */
    async function bindModalDownloadEvents(pdfBrochureUrl, listingName, pdfBrochureBlob) {
        const thankYouModal = document.querySelector('[data-thank-you-modal-paid]');
        const brochureDownloadStatus = thankYouModal && thankYouModal.querySelector('[data-brochure-download-status]');
        const brochureDownloadStatusCompleted = thankYouModal && thankYouModal.querySelector('[data-brochure-download-status-completed]');

        if (!thankYouModal || !brochureDownloadStatus) {
            return;
        }

        brochureDownloadStatus.style.display = 'none';

        const iconPath = document.getElementById('lottieAnimationIcon').value;

        if (window.NewHomeSource &&
            window.NewHomeSource.BrochureAnimationHandler &&
            typeof window.NewHomeSource.BrochureAnimationHandler.downloadLottieResources === 'function'
        ) {
            await window.NewHomeSource.BrochureAnimationHandler.downloadLottieResources('download-animation-container', iconPath);
        }
                 
        if (pdfBrochureBlob) {
            triggerDownloadBrochure(pdfBrochureUrl, listingName, pdfBrochureBlob);
            return;
        }

        brochureDownloadStatus.style.display = 'block';
        brochureDownloadStatusCompleted.style.display = 'none';

        if (!pdfBrochureUrl) {
            return;
        }

        const fetchedBlob = await window.NewHomeSource.BrochureHandler.getPdfBrochureBlob(pdfBrochureUrl);
        pdfBrochureBlob = fetchedBlob;

        triggerDownloadBrochure(pdfBrochureUrl, listingName, pdfBrochureBlob);
        brochureDownloadStatus.style.display = 'none';
        brochureDownloadStatusCompleted.style.display = 'block';
    }

    /**
     * Returns the lead action string for requesting a free brochure.
     *
     * @returns {string} The action name 'RequestFreeBrochure'.
     */
    function getRequestFreeBrochureLeadAction() {
        return 'RequestFreeBrochure';
    }

    /**
     * Binds a click event listener to the "Create Account" button.
     *
     * Searches for an element with the `[data-create-account]` attribute and attaches
     * the `handleCreateAccountClick` function as a click event handler if the element exists.
     */
    function bindCreateAccountButtonEvents() {
        const createAccountButton = document.querySelector('[data-create-account]');
        if (createAccountButton) {
            createAccountButton.addEventListener('click', handleCreateAccountClick);
        }
    }

    /**
     * Binds event listeners to elements within the thank you modal.
     * Specifically, attaches a click event handler to the modal's close button if it exists.
     */
    function bindEvents(){
        const closeButton = document.querySelector('[data-modal-close-element]');
        if (closeButton) {
            closeButton.addEventListener('click', closeButtonClickHandler);
        }
    }

    /**
     * Shows the thank you modal and binds its events.
     */
    function showThankYouModal(event) {
        const thankYouModal = document.querySelector('[data-thank-you-modal-paid]');
        const closeButton = thankYouModal.querySelector('[data-modal-close-element]');
        const thankYouModalElement  = document.querySelector("[data-thank-you-modal-displayed]");
        const downloadConfirmationElement = document.querySelector('[data-download-confirmation-desktop]');
        const thankyouDesktopPaidElement = document.querySelector('[data-thankyou-desktop-paid]');

        const detail = event && event.detail ? event.detail : {};
        const pdfBrochureUrl = detail.pdfBrochureUrl || null;
        const listingName = detail.listingName || null;
        const pdfBrochureBlob = detail.pdfBrochureBlob || null;
        const leadActionBtn = detail.leadActionBtn || null;

        if (thankYouModalElement) {
            thankYouModalElement.setAttribute('data-thank-you-modal-displayed', 'true');
        }

        toggleModal(thankYouModal);
        closeButton.focus();
        if (thankyouDesktopPaidElement) {
            thankyouDesktopPaidElement.hidden = true;
        }
        if (downloadConfirmationElement) {
            downloadConfirmationElement.hidden = true;
        }

        if (leadActionBtn === getRequestFreeBrochureLeadAction()) {
            if (downloadConfirmationElement) {
                downloadConfirmationElement.hidden = false;
            }
            bindModalDownloadEvents(pdfBrochureUrl, listingName, pdfBrochureBlob);
        } else {
            if (thankyouDesktopPaidElement) {
                thankyouDesktopPaidElement.hidden = false;
                bindCreateAccountButtonEvents();
            }
        }

        bindEvents();
    }

    document.body.addEventListener('showPaidThankYouModal', showThankYouModal);

}());
